import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c(VMain,{class:_vm.currentRouteName},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }